<nav class="menu-nav">
  <ul class="menu-list">
    <li *ngFor="let menu of menuItems" class="menu-item-wrapper">
      <!-- Elemento principal del menú -->
      <div
        class="menu-item"
        [ngClass]="{
          'menu-item--has-children': hasChildren(menu),
          'menu-item--expanded': menu.isChildVisible,
        }"
        (click)="navigate(menu)"
      >
        <a
          *ngIf="menu.route; else commandOrDefault"
          [routerLink]="menu.route"
          [queryParams]="menu.queryParams"
          [ngClass]="{ 'menu-item--active': menu.isActive }"
          class="menu-item-link"
        >
          @if (menu.primeIcon) {
            <i [ngClass]="menu.primeIcon" class="menu-item-icon"></i>
          }

          @if (menu.iconImage) {
            <img
              [src]="menu.iconImage"
              alt="{{ menu.label }} icon"
              class="menu-item-icon"
              width="24"
              height="24"
            />
          }
          <span class="menu-item-text">{{ menu.label }}</span>
        </a>
        <ng-template #commandOrDefault>
          <div
            class="menu-item-link"
            [ngClass]="{ 'cursor-pointer': menu.command }"
            [attr.tabindex]="menu.command ? 0 : null"
            (click)="menu.command ? menu.command() : null"
          >
            @if (menu.primeIcon) {
              <i [ngClass]="menu.primeIcon" class="menu-item-icon"></i>
            }

            @if (menu.iconImage) {
              <img
                [src]="menu.iconImage"
                alt="{{ menu.label }} icon"
                class="menu-item-icon"
                width="24"
                height="24"
              />
            }
            <span class="menu-item-text">{{ menu.label }}</span>
            <i
              *ngIf="hasChildren(menu) && visible"
              [ngClass]="
                menu.isChildVisible
                  ? 'pi pi-chevron-down'
                  : 'pi pi-chevron-right'
              "
              class="menu-item-arrow"
            ></i>
          </div>
        </ng-template>
      </div>

      <!-- Submenú -->
      <ul
        *ngIf="hasChildren(menu) && menu.isChildVisible && visible"
        class="submenu"
      >
        <p *ngIf="menu.description" class="menu-item-description">
          {{ menu.description }}
        </p>
        <li *ngFor="let child of menu.childs" class="submenu-item">
          <a
            [routerLink]="child.route ?? '#'"
            [queryParams]="child.queryParams"
            [ngClass]="{
              'submenu-item--active': child.isActive,
              'submenu-item-link': child.type == 'link' || child.type == null,
              'submenu-item-button': child.type != 'link' && child.type != null,
            }"
            (click)="child.command ? child.command() : null"
          >
            <i [ngClass]="child.primeIcon" class="submenu-item-icon"></i>
            <span class="submenu-item-text">{{ child.label }}</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</nav>
